<template>
	<div class="ks-checkbox-wrapper" :class="containerClasses" @click="toggle">
		<div class="ks-checkbox-container">
			<div class="ks-checkbox">
				<input type="checkbox" :checked="isChecked" :disabled="disabled" @click.prevent />
				<label class="box-label" :class="{ 'disabled': disabled }"></label>
			</div>
			<label v-if="label" class="ks-checkbox-text-label" :class="{ 'disabled': disabled }">{{ label }}</label>
		</div>
		<div v-if="hint && persistentHint" class="ks-checkbox-hint">{{ hint }}</div>
		<div v-if="errorMessages" class="ks-checkbox-error">{{ errorMessages }}</div>
	</div>
</template>

<script>
var uid = 0

export default {
	props: {
		"value": {
			type: [Boolean, Array],
			default: false
		},
		"label": {
			type: String,
			default: ""
		},
		"disabled": {
			type: Boolean,
			default: false
		},
		"readonly": {
			type: Boolean,
			default: false
		},
		"indeterminate": {
			type: Boolean,
			default: false
		},
		"trueValue": {
			default: true
		},
		"falseValue": {
			default: false
		},
		"color": {
			type: String,
			default: ""
		},
		"hideDetails": {
			type: Boolean,
			default: false
		},
		"hint": {
			type: String,
			default: ""
		},
		"persistentHint": {
			type: Boolean,
			default: false
		},
		"errorMessages": {
			type: String,
			default: ""
		},
		"inputValue": {
			default: undefined
		}
	},
	data () {
		return {
			lazyValue: this.value,
			id: uid++
		}
	},
	watch: {
		value (val) {
			this.lazyValue = val
		}
	},
	computed: {
		"computedId" () {
			return "ks-checkbox-" + this.id
		},
		"isChecked" () {
			if (Array.isArray(this.lazyValue)) {
				return this.lazyValue.indexOf(this.inputValue) > -1
			}
			return this.lazyValue === this.trueValue
		},
		"containerClasses" () {
			return {
				"ks-checkbox-disabled": this.disabled,
				"ks-checkbox-has-error": !!this.errorMessages,
				"ks-checkbox-hide-details": this.hideDetails
			}
		}
	},
	methods: {
		toggle () {
			if (this.disabled || this.readonly) return

			var newValue
			if (Array.isArray(this.lazyValue)) {
				newValue = [...this.lazyValue]
				var idx = newValue.indexOf(this.inputValue)
				if (idx > -1) {
					newValue.splice(idx, 1)
				} else {
					newValue.push(this.inputValue)
				}
			} else {
				newValue = this.isChecked ? this.falseValue : this.trueValue
			}

			this.lazyValue = newValue
			this.$emit("input", newValue)
			this.$emit("change", newValue)
		}
	}
}
</script>

<style>
.ks-checkbox-wrapper {
	position: relative;
	margin-bottom: 8px;
    padding-top: 4px;
    padding-bottom: 4px;
	cursor: pointer;
}

.ks-checkbox-wrapper.ks-checkbox-hide-details {
	margin-bottom: 0;
}

.ks-checkbox-wrapper.ks-checkbox-disabled {
	pointer-events: none;
}

.ks-checkbox-hint {
	font-size: 11px;
	color: var(--ks-font-color-4);
	margin-top: 4px;
	padding-left: 32px;
}

.ks-checkbox-error {
	font-size: 11px;
	color: var(--ks-col-danger);
	margin-top: 4px;
	padding-left: 32px;
}

.ks-checkbox-has-error .box-label {
	border-color: var(--ks-col-danger) !important;
}
</style>
